import React, { Component } from 'react';
import '../../src/index.scss';

class TagList extends Component {
    
    onTagClicked(ev, tag) {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.onTagClicked) { this.props.onTagClicked(tag) }
    }
    render(){
        var border = {borderBottom: "1px dashed #dddddd"}
        if (this.props.hideBorder) border = null;
        
        return (
            <div style={border}>
                <h4>{this.props.title}</h4>
                <div className="row">
                    <div className="col-sm-12">
                        {this.props.tags
                        ?   this.props.tags.map((tag, index) => {
                                return <><span className="badge badge-warning"
                                onClick={(ev) => {
                                    this.onTagClicked(ev, tag);
                                }}>{tag}</span>&nbsp;</>
                            })
                        :   null
                        }
                    </div>
                </div>
                <br/>
            </div>

        )
    }
}

export default TagList;